/* eslint-disable */
export default {
  add: '添加',
  noCalls: '无可用通话',
  activeCall: '进行中的通话',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
